import { Component, Input, OnInit } from '@angular/core'
import { Constants } from '../../../../api/constants/constants'
import { Environments } from '../../../../api/constants/environment.enum'
import { SidenavService } from '../../services/sidenav.service'

@Component({
    selector: 'ppw-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
    @Input() menuTitle!: string
    @Input() warn?: boolean
    @Input() singleButton?: boolean
    @Input() showMenu?: boolean
    isMobile?: boolean
    isProd?: boolean
    speedDialIsOpen?: boolean
    hasIconLeft?: boolean

    private readonly constants = Constants.getConstantsSingleton()

    private environment?: string

    constructor(public sideNavService: SidenavService) {}

    ngOnInit(): void {
        this.speedDialIsOpen = false
        this.setEnvironmentals()
    }

    toggleLeftMenu(): void {
        void this.sideNavService.toggle()
    }

    private setEnvironmentals(): void {
        this.environment = this.constants.ENVIRONMENT
        this.isProd = this.environment === Environments[Environments.PROD]
    }
}
